import StoragePacker from './StoragePacker';
var customerKey = 'app-login-customer';
var idempotencyKey = 'app-order-idempotency';
var couponKey = 'app-order-coupon';
var menuKey = 'app-menu-information';
var serviceTypeKey = 'service-type';
var generalKey = function (key) {
    return "app-" + key + "-information";
};
var localStorageAdapter = {
    storage: window.localStorage,
    host: location.host,
    getKey: function (key) {
        return key + "." + localStorageAdapter.host;
    },
    checkStoredData: function (storedData) {
        if (storedData === null) {
            localStorageAdapter.clearStorage();
        }
    },
    // TODO convert all to the general case.
    getCustomerBase: function () {
        var key = localStorageAdapter.getKey(customerKey);
        var storedCustomer = localStorageAdapter.storage.getItem(key);
        if (!storedCustomer) {
            return null;
        }
        localStorageAdapter.checkStoredData(storedCustomer);
        return storedCustomer;
    },
    setCustomerBase: function (customerBase) {
        var key = localStorageAdapter.getKey(customerKey);
        //@ts-ignore
        localStorageAdapter.storage.setItem(key, customerBase);
        return localStorageAdapter.getCustomerBase();
    },
    // General version
    getItem: function (key) {
        var generatedKey = generalKey(key);
        var adapterKey = localStorageAdapter.getKey(generatedKey);
        var item = localStorageAdapter.storage.getItem(adapterKey);
        if (!item) {
            return null;
        }
        var storedPackage = StoragePacker.unpack(item);
        localStorageAdapter.checkStoredData(storedPackage);
        return storedPackage;
    },
    setItem: function (key, item) {
        var generatedKey = generalKey(key);
        var adapterKey = localStorageAdapter.getKey(generatedKey);
        var storedPackage = StoragePacker.pack(item);
        try {
            localStorageAdapter.storage.setItem(adapterKey, storedPackage);
        }
        catch (error) {
            console.warn('storage adapter not supported');
            return null;
        }
        return localStorageAdapter.getItem(key);
    },
    removeInconsequentialItems: function () {
        // menu, categories, options, and option exceptions
        // are safe for removal
        var generatedKey = localStorageAdapter.getKey(menuKey);
        localStorageAdapter.storage.removeItem(generatedKey);
        generatedKey = generalKey('categories');
        localStorageAdapter.storage.removeItem(generatedKey);
        generatedKey = generalKey('options');
        localStorageAdapter.storage.removeItem(generatedKey);
        generatedKey = generalKey('option-exceptions');
        localStorageAdapter.storage.removeItem(generatedKey);
    },
    clearStorage: function () {
        localStorageAdapter.storage.clear();
    },
    getIdempotency: function () {
        var key = localStorageAdapter.getKey(idempotencyKey);
        var idempotency = localStorageAdapter.storage.getItem(key);
        if (!idempotency) {
            return null;
        }
        return idempotency;
    },
    setIdempotency: function (idempotency) {
        var key = localStorageAdapter.getKey(idempotencyKey);
        if (idempotency === null) {
            localStorageAdapter.storage.removeItem(key);
        }
        else {
            localStorageAdapter.storage.setItem(key, idempotency);
        }
        return localStorageAdapter.getIdempotency();
    },
    getCoupon: function () {
        var key = localStorageAdapter.getKey(couponKey);
        var coupon = localStorageAdapter.storage.getItem(key);
        if (!coupon) {
            return null;
        }
        return JSON.parse(coupon);
    },
    setCoupon: function (coupon) {
        var key = localStorageAdapter.getKey(couponKey);
        if (coupon === null) {
            localStorageAdapter.storage.removeItem(key);
        }
        else {
            coupon = JSON.stringify(coupon);
            localStorageAdapter.storage.setItem(key, coupon);
        }
        return localStorageAdapter.getCoupon();
    },
    getServiceType: function () {
        var key = localStorageAdapter.getKey(serviceTypeKey);
        var stored = localStorageAdapter.storage.getItem(key);
        if (!stored) {
            return null;
        }
        return Number(stored);
    },
    setServiceType: function (serviceType) {
        var key = localStorageAdapter.getKey(serviceTypeKey);
        localStorageAdapter.storage.setItem(key, serviceType);
        return localStorageAdapter.getServiceType();
    },
};
export default localStorageAdapter;



//////////////////
// WEBPACK FOOTER
// ./src/utils/LocalStorageAdapter.ts
// module id = null
// module chunks = 